import { createVNode } from "vue";
import DateTHead from './DateTHead';
import DateTBody from './DateTBody';

var DateTable = function DateTable(_, _ref) {
  var attrs = _ref.attrs;
  var prefixCls = attrs.prefixCls;
  return createVNode("table", {
    "class": "".concat(prefixCls, "-table"),
    "cellspacing": "0",
    "role": "grid"
  }, [createVNode(DateTHead, attrs, null), createVNode(DateTBody, attrs, null)]);
};

DateTable.inheritAttrs = false;
export default DateTable;